<script setup lang="ts">
    /**
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/1976532994
     */
    const props = defineProps<IWidgetProps<MemberLoginData>>();
    const { cmsComponentProps } = useWidget(props);
</script>

<template>
    <org-member-login v-bind="cmsComponentProps" />
</template>
